var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-kr",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kr-a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-95.8-.4h682.7v512H-95.8z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#kr-a)",
    transform: "translate(89.8 .4)scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-95.8-.4H587v512H-95.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-56.3 361.6 -101.3)scale(10.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kr-c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kr-b",
    d: "M-6-26H6v2H-6Zm0 3H6v2H-6Zm0 3H6v2H-6Z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kr-b",
    width: "100%",
    height: "100%",
    y: 44
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0 17v10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cd2e3a",
    d: "M0-12a12 12 0 0 1 0 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047a0",
    d: "M0-12a12 12 0 0 0 0 24A6 6 0 0 0 0 0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -6,
    r: 6,
    fill: "#cd2e3a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-123.7 191.2 62.2)scale(10.66667)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kr-c",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0-23.5v3M0 17v3.5m0 3v3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.014570f16b8183e5b49890b7c090a256.svg";
export { ForwardRef as ReactComponent };